// extracted by mini-css-extract-plugin
module.exports = {"container":"PhoneInput_container__dB_3_","label":"PhoneInput_label__rpRvp","placeholder":"PhoneInput_placeholder__owJpb","focused":"PhoneInput_focused__KgxxX"};